import axios from "axios";

const API = axios.create({
    baseURL: process.env.REACT_APP_APILIVEBASEURL,
    headers: {
        'x-api-version': '1.0.0',
        'Auth-Key': 'dmsfrontendapi',
        'Client-Service': 'USER-client',
        'Content-Type': 'application/json',
    }
})

const setAuthenticate = (token) => {
    API.interceptors.request.use((config) => {
        config.headers.Authorization = token;
        return config;

    });
};


API.interceptors.response.use((config) => {
    if (config?.data?.message === "Please Authenticate.") {

        localStorage.clear();
        window.location.reload();

    }
    return config;
});

//login
const loginApi = (body) => API.post('/login', body);
const publicKey = () => API.get('/publicKey', { responseType: 'text', });



// quotation
const quotationList = (body) => API.post('/quotation/quotationList', body)
const getQuotation = (body) => API.post('/quotation/getQuotation', body)
const quotationDelete = (body) => API.post('/quotation/deletequotation', body)
const quotationDiamondQuality = (body) => API.post('/quotation/diamondquality', body)
const quotationDmsDiamondQuality = (body) => API.post('/quotation/dmsDiamondquality', body)
const quotationColorStone = (body) => API.post('/quotation/colorstone', body)
const quatationAdd = (body) => API.post('/quotation/addquotation', body)
const quatationEdit = (body) => API.post('/quotation/quotationedit', body)
const styleNoQuotationDelete = (body) => API.post('/quotation/styleNoQuotationDelete', body)
const quotationLabourBreakup = (body) => API.post('/quotation/LabourBreakup', body);
const quotationMetalLotCode = (body) => API.post('/quotation/MetalLotCode', body)
// user
const userCustomerList = (body) => API.post("/UserCustomerList", body)
const userMasterActiveList = (body) => API.post('/userMasterActiveList', body)
const userCSCMappingList = (body) => API.post("/userCSCMappingList", body)
// auth
const userRegister = (body) => API.post("/userregister", body)
const userEdit = (body) => API.post("/useredit", body)
const userDelete = (body) => API.post("/userdelete", body)
const passwordEdit = (body) => API.post('/passwordedit', body)
const userList = (body) => API.post('/userlist', body)
// model
const modeList = (body) => API.post("/modelList", body)
const commonData = (body) => API.post("/commonData", body)
const createModel = (body) => API.post("/createModel", body)
const deleteModel = (modelId) => API.delete(`/deleteModel/${modelId}`)

const modelDirList = (body) => API.get("/modelDirList")

// log
const logsList = (body) => API.post('/logs/list', body)
const masterListAPI = (body) => API.post('/logs/masterlist', body)
const softwarelistAPI = (body) => API.post('/logs/softwarelist', body)
// master 
const materUserList = (body) => API.post('/master/user/list', body)

// delete
const deleteChainFromStoneDetail = (body) => API.post('/quotation/deleteMetalFromStone', body)

//labour 
const updateLabourBreakup = (body) => API.post('/quotation/labourBreakup/rateUpdateLabour', body)
const reCalculateLabourBreakup = (body) => API.post('/quotation/labourBreakup/RecalculateLabourBreakup', body)
const deleteLabourBreakup = (body) => API.post('/quotation/labourBreakup/deleteMetal', body)
// internalQulityApi

const internationalQuality = (body) => API.get('/quotation/qualityMaster');

const getPricingLotList = (body) => API.post("/priceChart/getLotList", body);

const getIpAddressList = () => API.get('/ipAddress/list');

const addIpAddress = (body) => API.post('/ipAddress/add', body);

const updateIpDetails = (body) => API.post('/ipAddress/edit', body);

const deleteIpAddress = (body) => API.delete('/ipAddress/delete', { data: body })

const imageFolderDetail = () => API.get("https://images.kgkdms.com/damImage/folderStructure")

const masterExcel = (body) => API.post('/excelData', body);

const uploadExcel = (body) => API.post('/bulkUpdate', body);

const languageTranslator = (body) => API.post('/user/translate', body);


const userStatusApi = () => API.get("/user-report");

const masterReportsApi = (modelName) => API.get(`/master-report/${modelName}`);
export const imageValidationApi = (model) => API.post(`/image-validation-report`, { model });
export const downloadImageValidation = (masterName) => {
    return API.get(`/image-validation-report/${masterName}`, {
        responseType: 'blob'
    });
};

const masterColumnShowApi = (body) => API.post('/columnShown/upload', body);

const downloadColumnNameApi = (masterName) => {
    return API.get(`/columnShown/download/dev/${masterName}`, {
        responseType: 'blob'
    });
};

const designExtractApi = (body) =>API.post(`${process.env.REACT_APP_DAM_IMAGE}/openai/data_extracted`, body);

const designValidationApi = (body)=> API.post('/extract/aggregate-validated', body);

const extractWeightApi = (body) => API.post('/extract/valiation-data', body)

export {
    API,
    setAuthenticate,
    deleteModel,
    createModel,
    materUserList,
    logsList,
    softwarelistAPI,
    masterListAPI,
    commonData,
    quotationDelete,
    deleteLabourBreakup,
    modeList,
    userCustomerList,
    passwordEdit,
    userDelete,
    userEdit,
    userRegister,
    userList,
    userCSCMappingList,
    userMasterActiveList,
    quotationList,
    getQuotation,
    quotationLabourBreakup,
    quotationDiamondQuality,
    quotationDmsDiamondQuality,
    quotationColorStone,
    quatationAdd,
    quatationEdit,
    styleNoQuotationDelete,
    deleteChainFromStoneDetail,
    loginApi,
    updateLabourBreakup,
    reCalculateLabourBreakup,
    quotationMetalLotCode,
    internationalQuality,
    modelDirList,
    getPricingLotList,
    getIpAddressList,
    addIpAddress,
    updateIpDetails,
    deleteIpAddress,
    imageFolderDetail,
    masterExcel,
    languageTranslator,
    uploadExcel,
    publicKey,
    userStatusApi,
    masterReportsApi,
    masterColumnShowApi,
    downloadColumnNameApi,
    designExtractApi,
    designValidationApi,
    extractWeightApi
}


